<template>
    <div class="w-100 h-100">
        <div class="row h-100">
            <div class="col-lg-12 d-flex flex-column h-100">
                <div class="np-header1 np-pt-3">{{ $t("UI.task.tasks") }}</div>
                <div class="np-group np-group-row np-pt-4 np-pb-3">
                    <div class="np-group np-rounded np-p-custom-1 align-items-center np-gray no-wrap np-mr-2">
                        <span class="np-mr-2 np-flex-1">{{ $t("UI.task.myTasks") }}</span>
                        <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>                            
                        <span class="np-mr-2">{{ tasksObject.today }}</span>
                        <svg class="np-mr-1"><use href="@/assets/images/icons/checked.svg#icon"></use></svg>                            
                        <span class="np-mr-2">{{ tasksObject.completed }}</span>
                        <svg class="np-mr-1"><use href="@/assets/images/icons/close2.svg#icon"></use></svg>                            
                        <span>{{ tasksObject.expired }}</span>
                    </div>   
                    <div class="np-group np-rounded np-p-custom-1 align-items-center np-outline np-mr-2">
                        <span class="no-wrap">{{ $t("UI.task.underReview") }}</span>
                        <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg> 
                        <span>11</span>
                    </div>  
                    <div class="np-group np-rounded np-p-custom-1 align-items-center np-outline np-mr-2">
                        <span class="no-wrap">{{ $t("UI.task.underControl") }}</span>
                        <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg> 
                        <span>11</span>
                    </div>  
                    <div class="np-field-group np-with-icon-right">
                        <input type="text" class="np-text-input np-outline" placeholder="Поиск" v-model="filters.title"/>
                        <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                    </div>                                                                      
                </div>
                <div class="np-panel np-flex-1 np-overflow-hidden">
                    <PerfectScrollbar>
                        <table class="np-table h-100">
                            <thead class="np-table-header">
                                <tr class="np-table-row">
                                    <th class="np-table-header-cell" style="width: 25%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.task") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('title')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('title')" /> 
                                            </button>
                                        </div>
                                    </th>
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.expired") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('deadline')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('deadline')" /> 
                                            </button>
                                        </div>
                                    </th>                                                          
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.column") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('status')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('status')" /> 
                                            </button>
                                        </div>
                                    </th>  
                                    <th class="np-table-header-cell" style="width: 80px;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">%</div>
                                            <button class="np-btn-link" @click="attachSorting('completion_percent')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('completion_percent')" /> 
                                            </button>
                                        </div>
                                    </th>                                                         
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.реrformers") }}</div>
                                            <button class="np-btn-link">
                                                <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/list2.svg#icon"></use></svg> 
                                            </button>
                                        </div>
                                    </th>   
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.priority") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('priority')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('priority')" /> 
                                            </button>
                                        </div>
                                    </th>   
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.begin") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_start')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_start')" />  
                                            </button>
                                        </div>
                                    </th>                                             
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.end") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_end')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_end')" /> 
                                            </button>
                                        </div>
                                    </th>                                                                                                                   
                                </tr>
                            </thead>
                            <tbody class="np-table-body">
                                <template v-for="eTask in this.taskList">
                                    <tr class="np-table-row" @dblclick="showModTask(eTask.task.id, eTask.status.id)">
                                        <td class="np-table-cell">
                                            <div class="np-group justify-content-between align-items-center">
                                                <button class="np-btn-sm np-toggler me-2" 
                                                        v-if="eTask.task.subtask.length > 0" 
                                                        @click.stop="this.expandRow($event, 'pTask_' + eTask.task.id)">
                                                </button>
                                                <div class="flex-grow-1 np-ellipsis" :class="{ 'completed' : eTask.task.date_actual_end }">
                                                    {{ eTask.task.title }}
                                                </div>
                                                <div class="np-table-badge ms-1" v-if="eTask.task.subtask.length > 0">
                                                    <svg class="np-mr-1"><use href="@/assets/images/icons/folder-tree.svg#icon"></use></svg>
                                                    <span class="np-font-s np-lh-s">{{ eTask.task.subtask.length }}</span> 
                                                </div>
                                            </div>
                                        </td>
                                        <td class="np-table-cell">
                                            <IndicatorDaysTo 
                                                :dateStart="eTask.task.date_planned_start"
                                                :dateEnd="eTask.task.date_planned_end" 
                                                v-if="!eTask.task.date_actual_end"
                                            />                                         
                                        </td>
                                        <td class="np-table-cell">{{ eTask.status.title }}</td>
                                        <td class="np-table-cell">
                                            <IndicatorProgress :progress="eTask.task.completion_percent" />
                                        </td>
                                        <td class="np-table-cell">
                                            <CobaltProfilesList :users="eTask.task.performer" :short="false" :wrapperClasses="mt-2" />
                                        </td>
                                        <td class="np-table-cell">
                                            <div class="np-badge text-center" :class="eTask.priority.class">
                                                {{ $t(eTask.priority.label) }}
                                            </div>                                                                
                                        </td>
                                        <td class="np-table-cell">{{ localeDateTime(eTask.task.date_planned_start) }}</td>
                                        <td class="np-table-cell">{{ localeDateTime(eTask.task.date_planned_end) }}</td>
                                    </tr>
                                    <template v-for="eSubTask in eTask.task.subtask">
                                        <div class="np-table-row hidden" :class="'pTask_' + eTask.task.id" @dblclick="showModTask(eTask.task.id, eTask.status.id, 'params', eSubTask.id)">
                                            <div class="np-table-cell ps-4">
                                                <div class="np-group justify-content-between align-items-center ps-3">
                                                    <svg class="np-mr-1"><use href="@/assets/images/icons/folder-tree.svg#icon"></use></svg>
                                                    <div class="flex-grow-1 np-ellipsis">{{ eSubTask.title }}</div>
                                                </div>
                                            </div>
                                            <div class="np-table-cell">
                                                <IndicatorDaysTo :dateStart="eSubTask.date_planned_start" :dateEnd="eSubTask.date_planned_end" v-if="!eSubTask.date_actual_end"/>                       
                                            </div>
                                            <div class="np-table-cell">{{ eSubTask.title }}</div>
                                            <div class="np-table-cell"><span class="np-badge np-warning">33%</span></div>
                                            <div class="np-table-cell">
                                                <div class="np-profile-list mt-2">
                                                    <div class="np-profile-list__item" v-for="item_s in eSubTask.performer">
                                                        <CobaltProfile 
                                                            :firstName="item_s.first_name" 
                                                            :lastName="item_s.last_name" 
                                                            :short="eSubTask.performer.length > 1 ? true : false"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="np-table-cell">
                                            
                                            </div>
                                            <div class="np-table-cell">{{ localeDateTime(eSubTask.date_planned_start) }}</div>
                                            <div class="np-table-cell">{{ localeDateTime(eSubTask.date_planned_end) }}</div>
                                        </div>
                                    </template>
                                </template>
                            </tbody>                                                                                         
                        </table>
                    </PerfectScrollbar>
                </div>
            </div>
        </div>            
    </div>
</template>

<script>

import { localeDate, localeDateTime, formatBytes } from '@/utils/format'
import TaskCardSimple  from "@/components/TaskCardSimple.vue" 
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapGetters, mapActions } from 'vuex';
import Config from '../../../config.js'
import CobaltProfilesList from '../parts/CobaltProfilesList.vue'
import IndicatorProgress from '@/components/elements/IndicatorProgress.vue'

function compareValues(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true }); // Сравнение строк с учетом чисел
  }
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

function daysTo(date, dateActualEnd) {
    if (dateActualEnd !== null && dateActualEnd !== undefined) return -1;
    if (date === null || date === undefined) return -1;

    const end = date;
    const current = new Date().getTime() / 1000;

    if (end > 0 && current < end) {
        return parseInt((end - current) / 86400);
    }
    return 0;
}

function priorityTo(value) {
    let newValue = 0
    switch (value) {
        case 0: newValue = 0; break;
        case 1: newValue = 4; break;
        case 2: newValue = 3; break;
        case 3: newValue = 2; break;
        case 4: newValue = 1; break;
    } 

    return newValue
}

function sortByMultipleFields(array, sorts) {
    return array.sort((a, b) => {

        const activeSorts = Object.entries(sorts)
        .filter(([field, direction]) => direction !== 'none')
        .map(([field, direction]) => ({ field, direction }))

        for (const { field, direction } of activeSorts) {
            const multiplier = direction === 'desc' ? -1 : 1

            let valueA, valueB
            if (field === 'status') {
                valueA = a.status.title
                valueB = b.status.title
            } else if (field === 'deadline') {
                valueA = daysTo(a.task.date_planned_end, a.task.date_actual_end)
                valueB = daysTo(b.task.date_planned_end, b.task.date_actual_end) 
            } else if (field === 'priority') {
                valueA = priorityTo(a.task.priority)
                valueB = priorityTo(b.task.priority)
            } else {                    
                valueA = a.task[field]
                valueB = b.task[field]
            }

            const result = compareValues(valueA, valueB);
            if (result !== 0) return result * multiplier;
        }

        return 0
    })
}


export default {
    components: {
        TaskCardSimple,
        CobaltProfilesList,
        VueSlider,
        IndicatorDaysTo,
        IndicatorProgress
    },
    props: {
        project: {
            type: Object,
            default: {}
        },      
        statuses: {
            type: Array,
            default: []
        },           
        tasks: {
            type: Object,
            default: {}
        },  
        users: {
            type: Array,
            default: []
        },            
        priorityValues: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            Config,
            compInfo: null,
            taskFilter: '',
            filterVisible: false,
            filters: {
                title: '',
                deadline: null,
                status: '',
                completion_percent: 100,
                performers: [],
                priority: [],
                files: 0,
                date_planned_start: null,
                date_planned_end: null
            },
            sorts: {
                title: 'none',
                deadline: 'none',
                status: 'none',
                completion_percent: 'none',
                performers: 'none',
                priority: 'none',
                files: 'none',
                date_planned_start: 'none',
                date_planned_end: 'none'
            },            
            selectedStatuses: []
        }
    },
    computed: {
        tasksObject: {
            get() {
                let result = {
                    today: 0,
                    expired: 0,
                    failed: 0,
                    completed: 0
                }    
                let today = new Date().getTime() / 1000

                for (var key in this.tasks) {
                    this.tasks[key].forEach(task => {

                        if (!!task.date_actual_end) {
                            result.completed++
                        }
                        const start = task.date_planned_start
                        const end   = task.date_planned_end
                        // today
                        if ( !start ) {
                            if (end) {
                                if (today < end) {
                                    result.today++
                                }
                            } else {
                                result.today++
                            }
                        } else 
                            if (!end) {
                                if (start < today) {
                                    result.today++
                                }
                            } else {
                                if (start < today && end > today) {
                                    result.today++
                                }
                            }
                        // Expired
                        if (start > 0 && end > 0) {
                            const section = ( end - start ) / 3
                            const current =  new Date().getTime() / 1000
                            
                            if (end - section < current && current < end) {
                                result.expired++
                            }                                
                        }                        
                        // failed
                        if ( start > 0 && end > 0 && end < today) {
                            result.failed++
                        } 
                    })                       
                }                

                return result
            }
        },        
        taskList: {
            get() {
                const searchTerm = this.filters.title.trim().toLowerCase()
                const fieldsToSearch = ["title", "description"]
                let list = []
                
                this.statuses.forEach(element => {
                    element.tasks.forEach(taskItem => {
                        if (taskItem.title.includes(this.taskFilter) || taskItem.description.includes(this.taskFilter)) {
                            let item = { "status": element, "task": taskItem, "priority": this.getPriority(taskItem) }
                            list.push(item)
                            console.log(taskItem.date_planned_end)    
                        }
                    })
                })

                const sortedTasks = sortByMultipleFields(list, this.sorts);

                const result = sortedTasks.filter(item => {
                    return fieldsToSearch.some(field => 
                        String(item.task[field]).toLowerCase().includes(searchTerm)
                    )
                })

                return result
            }
        },
        statusList: {
            get() {
                let list = []
                
                this.statuses.forEach(element => {
                    list.push(element.title)
                })

                return list                
            }
        }          
    },
    methods: {
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']),     
        localeDate,
        localeDateTime,  
               
        getPriority(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority)
            return priorityObj
        }, 
        sortIcon(field) {
            const direction = this.sorts[field]
            if (direction === 'asc') {
                return require('@/assets/images/icons/sort-asc.svg#icon')
            } else if (direction === 'desc') {
                return require('@/assets/images/icons/sort-desc.svg#icon')
            } else if (direction === 'none') {
                return require('@/assets/images/icons/sort-none.svg#icon')
            }
            return ''
        },
        attachSorting(field) {           
            if (!(field in this.sorts)) {
                console.error(`Поле "${field}" не существует в объекте sorts.`)
                return
            }

            Object.keys(this.sorts).forEach((key) => {
                if (key !== field) {
                    this.sorts[key] = 'none'
                }
            })
            
            const currentValue = this.sorts[field];

            if (currentValue === 'none') {
                this.sorts[field] = 'asc'
            } else if (currentValue === 'asc') {
                this.sorts[field] = 'desc'
            } else {
                this.sorts[field] = 'none'
            }
        },           
        showFilters() {
            this.filterVisible = !this.filterVisible
        }, 
        showModTask(taskId, statusId, taskActiveTab="params", activeSubTaskID=null) {
            this.$emit('showModTask', taskId, statusId, taskActiveTab, activeSubTaskID)
        },   
        expandRow(event, rowSelector) {
            const targetElement = event.target
            const elements = document.querySelectorAll(`.${rowSelector}`)
            
            targetElement.classList.toggle('expanded')

            elements.forEach((element) => {
                element.classList.toggle('hidden')
            })
        },  
        refresh() {
            this.$emit('refresh')
        }          
    }

}
</script>

<style>
</style>